import { track } from '@zillow/universal-analytics';
import newLaneEventProps from './newLaneEventProps';
export var ClickstreamEvent = function ClickstreamEvent(clickstreamPayload) {
  track({}, Object.assign({
    integrations: {
      gtm: false
    }
  }, clickstreamPayload && {
    newLaneEvent: [clickstreamPayload, {
      integrations: {
        gtm: false
      }
    }]
  }));
};
ClickstreamEvent.propTypes = {
  clickstreamPayload: newLaneEventProps
};
ClickstreamEvent.defaultProps = {
  clickstreamPayload: {}
};